module.exports = __webpack_public_path__ + "img/OurServiceAI_pic2.fd3e3881.png";